import React from 'react';

const FourD = () => {
  return (
    <div className="relative z-10 min-h-screen w-full">
      {/* This page only shows the torus animation - no other content */}
    </div>
  );
};

export default FourD;
